export enum FavoriteIposFormBlock {
  Root = 'FavoriteIposForm',
}
